module.exports = __webpack_public_path__ + "img/chain_usdc.fc28548d.png";